<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
  >
    <g transform="translate(-1278 -443)">
      <path
        d="M20.25,6.75,9.75,17.25,4.5,12"
        transform="translate(1274.625 440)"
        fill="none"
        stroke="#23d440"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCheck',

  props: {
    size: { type: [String, Number], default: '18px' },
  }
}
</script>